var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oie-header-switch',{attrs:{"value":_vm.clientModel.useListPrice,"is-for":"list-price-switch","label-text":_vm.tStatic('listPriceShowing')},on:{"toggle":_vm.toggleCheckbox}})}
var staticRenderFns = []

export { render, staticRenderFns }